import {
  AccountBalanceOutlined,
  BatchPredictionOutlined,
  CurrencyRupeeOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  GroupOutlined,
  HandshakeOutlined,
  PersonOutlined,
  StoreOutlined,
  Storefront,
} from "@mui/icons-material";

export const NAV_ITEMS: Record<
  string,
  {
    label: string;
    icon: any;
    path: string;
  }
> = {
  customers: {
    label: "Customers",
    icon: GroupOutlined,
    path: "/customers",
  },

  partners: {
    label: "Partners",
    icon: HandshakeOutlined,
    path: "/partners",
  },

  trades: {
    label: "Trades",
    icon: Storefront,
    path: "/trades",
  },

  loans: {
    label: "Loans",
    icon: AccountBalanceOutlined,
    path: "/loans",
  },

  payments: {
    label: "Payments",
    icon: CurrencyRupeeOutlined,
    path: "/payments",
  },

  reports: {
    label: "Reports",
    icon: DescriptionOutlined,
    path: "/reports/debit-credit-reports",
  },

  markets: {
    label: "Markets",
    icon: StoreOutlined,
    path: "/markets",
  },

  risk_engine: {
    label: "Risk Engine",
    icon: DashboardOutlined,
    path: "/risk-engine",
  },

  price_prediction: {
    label: "Price Prediction",
    icon: BatchPredictionOutlined,
    path: "/price-prediction",
  },

  my_profile: {
    label: "My Profile",
    icon: PersonOutlined,
    path: "/my-profile",
  },
};
